import { Card, Space, Row } from 'antd';
import PropTypes from 'prop-types';

export const DataCard = ({ 
  index, 
  isSelected, 
  onToggleSelect, 
  details,
  cardName="Item",
  actions=[],
  disabled=false
}) => {
  // Only show index if one is provided (pinned items usually won't pass an index)
  const hasIndex = index !== undefined && index !== null;
  const paddedIndex = hasIndex ? String(index + 1).padStart(2, '0') : '';

  return (
    <Card
      hoverable={!disabled} 
      onClick={disabled ? null : onToggleSelect}
      style={{
        borderColor: isSelected ? '#1677ff' : '#E3E3E3',
        borderWidth: isSelected ? 2 : 1,
        transition: 'all 0.2s ease-in-out',
        marginBottom: 0,
        backgroundColor: isSelected ? '#f0f5ff' : '#f0f2f5' 
      }}
      styles={{
        header: { borderBottom: '1px solid #f0f0f0', padding: '12px 16px', minHeight: 'auto' },
        body: { padding: '16px' }
      }}
      title={
        <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Space size="middle">
            {!hasIndex && isSelected ? (
              <span style={{ fontWeight: 600, color: '#1677ff', fontSize: 14 }}>
                Selected {cardName}
              </span>
            ) : (
              hasIndex && <span style={{ fontWeight: 400, color: '#595959' }}>{paddedIndex}</span>
            )}
          </Space>
          {actions && actions.length > 0 && (
            <Space size="small">
              {actions}
            </Space>
          )}
        </Row>
      }
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {details.map((row, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', textAlign: 'left' }}>
            <div style={{ minWidth: '100px', color: '#8c8c8c', fontSize: '14px' }}>
              {row.label}
            </div>
            <div style={{ flex: 1, color: '#262626', fontSize: '14px', fontWeight: 500 }}>
              {row.value}
            </div>
          </div>
        ))}
      </Space>
    </Card>
  );
};

DataCard.propTypes = {
  index: PropTypes.number,
  isSelected: PropTypes.bool.isRequired,
  onToggleSelect: PropTypes.func.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired
    })
  ).isRequired,
  cardName: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool
};
